export default "__VITE_ASSET__1c566b51__"